export { default } from './ProductScreen';
export * from './ProductScreen';
